// Copyright (c) 2019 Wildan Maulana Syahidillah
var noop = function () { };
var AppIdle = /** @class */ (function () {
    function AppIdle(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.options = {
            timeout: 30000,
            onActive: noop,
            onIdle: noop,
            onCancel: noop,
            recurIdleCall: false,
            events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'wheel'],
            multi: true,
            storageKey: 'AppIdle',
            eventTarget: window
        };
        this.eventHandler = function (event) {
            /* istanbul ignore else*/
            if (_this.options.multi) {
                _this.notifyWindows();
            }
            _this.notifyActive(event);
        };
        this.storageHandler = function (event) {
            /* istanbul ignore else*/
            if (event.key === _this.options.storageKey) {
                _this.notifyActive(event);
            }
        };
        this.options = Object.assign({}, this.options, options);
    }
    /**
     * Starts the idle timer
     */
    AppIdle.prototype.start = function () {
        var _this = this;
        this.options.events.forEach(function (event) {
            _this.options.eventTarget.addEventListener(event, _this.eventHandler);
        });
        /* istanbul ignore else*/
        if (this.options.multi) {
            this.options.eventTarget.addEventListener('storage', this.storageHandler);
        }
        this.startTimer();
        return this;
    };
    /**
     * Stops the idle timer
     */
    AppIdle.prototype.stop = function () {
        var _this = this;
        this.options.events.forEach(function (event) {
            _this.options.eventTarget.removeEventListener(event, _this.eventHandler);
        });
        /* istanbul ignore else*/
        if (this.options.multi) {
            this.options.eventTarget.removeEventListener('storage', this.storageHandler);
        }
        localStorage.removeItem(this.options.storageKey);
        this.stopTimer();
        return this;
    };
    /**
     * Resets the idle state and last active
     */
    AppIdle.prototype.reset = function () {
        this.idleState = false;
        this.lastActive = 0;
        return this;
    };
    /**
     * Returns whether or not the user is idle
     */
    AppIdle.prototype.isIdle = function () {
        return this.idleState;
    };
    /**
     * Returns how long the user has been idle
     */
    AppIdle.prototype.getElapsedTime = function () {
        return Date.now() - this.lastActive;
    };
    /**
     * Returns the remaining time until the user is deemed idle
     */
    AppIdle.prototype.getRemainingTime = function () {
        return this.options.timeout - this.getElapsedTime();
    };
    /**
     * Returns the timestamp the user was last active
     */
    AppIdle.prototype.getLastActiveTime = function () {
        return this.lastActive;
    };
    AppIdle.prototype.startTimer = function () {
        var _this = this;
        var timer = this.options.recurIdleCall
            ? {
                set: window.setInterval.bind(window),
                clear: window.clearInterval.bind(window)
            }
            : {
                set: window.setTimeout.bind(window),
                clear: window.clearTimeout.bind(window)
            };
        // save timer start, to calculate idle length
        this.lastActive = Date.now();
        var intervalId = timer.set(function () {
            _this.idleState = true;
            _this.options.onIdle();
        }, this.options.timeout);
        this.clearTimer = function () { return timer.clear(intervalId); };
    };
    AppIdle.prototype.stopTimer = function () {
        /* istanbul ignore else*/
        if (this.clearTimer) {
            this.clearTimer();
        }
        this.clearTimer = null;
    };
    AppIdle.prototype.restartTimer = function () {
        this.stopTimer();
        this.startTimer();
    };
    AppIdle.prototype.notifyActive = function (event) {
        /* istanbul ignore else*/
        if (this.idleState) {
            this.idleState = false;
            this.options.onActive();
        }
        this.options.onCancel(event, this.getElapsedTime());
        this.restartTimer();
    };
    AppIdle.prototype.notifyWindows = function () {
        localStorage.setItem(this.options.storageKey, Date.now().toString());
    };
    return AppIdle;
}());
export default AppIdle;
